import React from 'react';
import PropTypes from 'prop-types';
import getErrorClass from '../../utils/getErrorClass';
import ErrorFieldMessage from '../ErrorFieldMessage';

const FormField = ({ children, field }) =>
  <div className={getErrorClass('form-field', field)}>
    {children}
    <ErrorFieldMessage field={field} />
  </div>;

FormField.propTypes = {
  children: PropTypes.node.isRequired,
  field: PropTypes.object.isRequired
};

FormField.defaultProps = {
  field: { meta: {} }
};

export default FormField;
